import { render, staticRenderFns } from "./ModalObserverVouchers.vue?vue&type=template&id=3ae0a694&"
import script from "./ModalObserverVouchers.vue?vue&type=script&lang=js&"
export * from "./ModalObserverVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports